import { useQuery } from '@apollo/react-hooks';
import { useUser } from '../useUser';
import { AccountDesignerPreferencesVertical } from '../useDesigners';
import {
  GET_DESIGNER_PREFERENCES_QUERY,
  GetDesignerPreferencesQuery,
  GetDesignerPreferencesQueryVariables
} from './useDesignerPreferences.rest';

export const useDesignerPreferences = (vertical: AccountDesignerPreferencesVertical) => {
  const { user } = useUser();

  const { data, loading, error } = useQuery<
    GetDesignerPreferencesQuery,
    GetDesignerPreferencesQueryVariables
  >(GET_DESIGNER_PREFERENCES_QUERY, {
    variables: { userId: user.id as string, vertical },
    ssr: false,
    skip: !user.isLoggedIn
  });

  return {
    data: data?.getDesignerPreferences,
    loading,
    error
  };
};
